import DpmV3Release from "./01-dpm-v3-release";

export type NewsItemType = {
  datePublished: Date;
  dateHidden?: Date;
  page: any;
};

export const newsItems: NewsItemType[] = [DpmV3Release].sort((a, b) => {
  const dateA = a.datePublished?.getTime?.() || 0;
  const dateB = b.datePublished?.getTime?.() || 0;

  return dateB - dateA;
});
